import { combineReducers } from "redux";

import ProductFilter from "./ProductFilterReducer";
import ProductSaveFilter from "./ProductSaveData";


const appReducer = combineReducers({
    ProductFilter, ProductSaveFilter
    
});

const reducers = (state, action) => {
    return appReducer(state, action);
};

export default reducers;
